import getConfig from 'next/config';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
const { publicRuntimeConfig } = getConfig();
import { Button, Form, Spinner } from 'react-bootstrap';
import * as React from 'react';
import NumberFormat from 'react-number-format';
import ReviewBox from '../components/ReviewBox';

import { xVerifyService } from 'services';
import { checkEmail } from '../helpers/emailChecker';
import { usePrevious } from '../hooks';
import { NextSeo } from 'next-seo';
import { config } from '_config';
import { getHostname } from "../helpers/common";

const { apiUrl } = config;

function Contact() {
  let phone = process.env.NEXT_PUBLIC_PHONE_APP;
  let emailCompany = process.env.NEXT_PUBLIC_EMAIL_APP;

  const [suspendedAction, setSuspendedAction] = React.useState(false);
  const [state, setState] = React.useState({
    name: '',
    email: '',
    message: '',
    subject: '',
    validated: false,
    isSended: false,
    error: false,
    verifying: false,
    verificationResult: null,
  });

  const prevState = usePrevious(state);

  function handleChange(e) {
    if (e.target.type === 'email') {
      setState((prevState) => ({
        ...prevState,
        [e.target.name || e.target.id]: e.target.value,
        verificationResult: null,
      }));
    } else {
      setState((prevState) => ({
        ...prevState,
        [e.target.name || e.target.id]: e.target.value,
      }));
    }
  }

  const verifyEmail = React.useCallback(() => {
    if (!state.verificationResult && checkEmail(state.email)) {
      setState((prevState) => ({ ...prevState, verifying: true }));

      xVerifyService.verifyEmail(state.email).then((result) => {
        setState((prevState) => {
          return {
            ...prevState,
            verificationResult: result,
            verifying: false,
          };
        });
      });
    }
  }, [state]);

  const handleBlur = React.useCallback(
    (e) => {
      const { type } = e.target;
      if (type === 'email') {
        verifyEmail();
      }
    },
    [verifyEmail]
  );

  const handleSubmit = React.useCallback(
    (e) => {
      e.preventDefault();
      e.stopPropagation();

      if (state.verifying) {
        setSuspendedAction(true);
        return;
      }

      setSuspendedAction(false);

      const form = e.currentTarget;
      if (form.checkValidity() === false) {
        const section = document.querySelector('.form-control:invalid');
        section.scrollIntoView();
      } else {
        const contactus = {
          name: state.name,
          email: state.email,
          subject: state.subject,
          category: 'TRADEMARKS',
          message: state.message,
          domain: getHostname(),
        };

        let salePage = window.location.href;
        let salePageURLArr = salePage.split('/');
        let salePageURL = (
          salePageURLArr[0] +
          '//' +
          salePageURLArr[2]
        ).replace(/\/+$/, '');
        let url = apiUrl + '/contact-us';
        let fallbackURL = `${salePageURL}/crm` + '/contact-us';

        fetch(url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(contactus),
        })
          .then(async (response) => {
            if (response.status === 200 || response.status === 204) {
              setState((prevState) => ({ ...prevState, isSended: true }));
            } else {
              setState((prevState) => ({ ...prevState, error: true }));
            }
          })
          .catch((error) => {
            if (error.request) {
              fetch(fallbackURL, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                },
                body: JSON.stringify(contactus),
              }).then(async (response) => {
                if (response.status === 200 || response.status === 204) {
                  setState((prevState) => ({ ...prevState, isSended: true }));
                } else {
                  setState((prevState) => ({ ...prevState, error: true }));
                }
              });
            }
          });
      }
      setState((prevState) => ({ ...prevState, validated: true }));
    },
    [state]
  );

  React.useEffect(() => {
    if (prevState?.verifying && !state.verifying && suspendedAction) {
      document.getElementById('ContactUsSendButton')?.click();
    }
  }, [prevState, state, suspendedAction]);

  React.useEffect(() => {
    if (prevState?.email === '') {
      verifyEmail();
    }
  }, [prevState, verifyEmail]);

  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3,
      slidesToSlide: 3, // optional, default to 1.
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
      slidesToSlide: 2, // optional, default to 1.
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
      slidesToSlide: 1, // optional, default to 1.
    },
  };

  const isEmailValid =
    state.verificationResult?.status && !state.verifying
      ? xVerifyService.VALID_EMAIL_STATUSES.includes(
          state.verificationResult.status
        )
      : undefined;
  const isEmailInvalid =
    state.verificationResult?.status && !state.verifying
      ? xVerifyService.INVALID_EMAIL_STATUSES.includes(
          state.verificationResult.status
        )
      : undefined;
  const invalidEmailMessage =
    xVerifyService.VALIDATION_MESSAGE[state.verificationResult?.reason] ||
    'You must provide a valid email address';

  if (state.error) {
    return (
      <div className="contact">
        <div className="side-wrapper">
          <div className="left-side">
            <div className="banner">
              <div className="mobile">
                <h1>Contact </h1>
                <h2>Customer Service</h2>
              </div>
            </div>
          </div>
          <div className="right-side">
            <div className="form">
              <div className="desktop">
                <h1>Contact </h1>
                <h2>Customer Service</h2>
              </div>
              <p>Error</p>
            </div>
          </div>
        </div>

        <div className="info">
          <div className="info-box">
            <div className="icon">
              <img
                src={`${publicRuntimeConfig.basePath}/call.png`}
                alt=""
                layout="fill"
              />
            </div>
            <div className="copy">
              <h4>CALL</h4>
              <p>
                <a href={'tel:' + phone} style={{ color: '#7B848D' }}>
                  <NumberFormat
                    value={phone.substring(2)}
                    displayType={'text'}
                    format="(###)### - ####"
                  />
                </a>
              </p>
            </div>
          </div>
          <div className="info-box">
            <div className="icon">
              <img
                src={`${publicRuntimeConfig.basePath}/email.png`}
                alt=""
                layout="fill"
              />
            </div>
            <div className="copy">
              <h4>EMAIL</h4>
              <p>
                <a href={'mailto:' + emailCompany} style={{ color: '#7B848D' }}>
                  {emailCompany}
                </a>
              </p>
            </div>
          </div>
          <div className="info-box">
            <div className="icon">
              <img
                src={`${publicRuntimeConfig.basePath}/email.png`}
                alt=""
                layout="fill"
              />
            </div>
            <div className="copy">
              <h4>HOURS</h4>
              <p>
                Monday - Friday:
                <br />
                9am - 5pm PST
              </p>
            </div>
          </div>
        </div>

        <div className="contact-feedback">
          <Carousel
            responsive={responsive}
            showDots={true}
            infinite={true}
            renderDotsOutside={true}
          >
            <ReviewBox
              rate={5}
              name="Mark D"
              company="Trademark Genius"
              text="Trademark Genius helped register my companies trademark.
The process was simple, their customer service was excellent, and my trademark was registered without any issues.
Highly recommend Trademark Genius."
            />
            <ReviewBox
              rate={5}
              name="Kelly T"
              company="Trademark Genius"
              text="I contacted Trademark Genius after running into many issues trying to register my companies trademark myself.
They helped solve every issue i ran into. Would definitely recommend spending the money to have professionals handle
this process."
            />
            <ReviewBox
              rate={5}
              name="Terry F"
              company="Trademark Genius"
              text="Got my trademark registered with USPTO without any issues.
Their dashboard is a great tool and helped me track the progress of my application all the way to completion.
Will use them again for any other TM needs."
            />
            <ReviewBox
              rate={5}
              name="Devin M"
              company="Trademark Genius"
              text="My experience with TMG was great.
Their customer service team was friendly and helpful.
The process was quick & simple.
Thanks!"
            />
            <ReviewBox
              rate={5}
              name="Lisa N"
              company="Trademark Genius"
              text="My trademark registration was a unique situation that required some extra work, the team helped guide me through this daunting process and got my application submit to USPTO (and was approved without issues)
Thanks TMG!"
            />
            <ReviewBox
              rate={5}
              name="Marshall N"
              company="Trademark Genius"
              text="Great experience with Trademark Genius. They were knowledgeable, quick and accurate.
Helped iron out a few issues the USPTO was giving my application.
I’d definitely use them again."
            />
          </Carousel>
        </div>
      </div>
    );
  } else if (state.isSended) {
    return (
      <div className="contact">
        <div className="side-wrapper">
          <div className="left-side">
            <div className="banner">
              <div className="mobile">
                <h1>Contact </h1>
                <h2>Customer Service</h2>
              </div>
            </div>
          </div>
          <div className="right-side">
            <div className="form">
              <div className="desktop">
                <h1>Contact </h1>
                <h2>Customer Service</h2>
              </div>
              <p>
                Thank you for your question. Our agents will respond to your
                inquiry as quickly as possible.
              </p>
            </div>
          </div>
        </div>

        <div className="info">
          <div className="info-box">
            <div className="icon">
              <img
                src={`${publicRuntimeConfig.basePath}/call.png`}
                alt=""
                layout="fill"
              />
            </div>
            <div className="copy">
              <h4>CALL</h4>
              <p>
                <a href={'tel:' + phone} style={{ color: '#7B848D' }}>
                  <NumberFormat
                    value={phone.substring(2)}
                    displayType={'text'}
                    format="(###)### - ####"
                  />
                </a>
              </p>
            </div>
          </div>
          <div className="info-box">
            <div className="icon">
              <img
                src={`${publicRuntimeConfig.basePath}/email.png`}
                alt=""
                layout="fill"
              />
            </div>
            <div className="copy">
              <h4>EMAIL</h4>
              <p>
                <a href={'mailto:' + emailCompany} style={{ color: '#7B848D' }}>
                  {emailCompany}
                </a>
              </p>
            </div>
          </div>
          <div className="info-box">
            <div className="icon">
              <img
                src={`${publicRuntimeConfig.basePath}/email.png`}
                alt=""
                layout="fill"
              />
            </div>
            <div className="copy">
              <h4>HOURS</h4>
              <p>
                Monday - Friday:
                <br />
                9am - 5pm PST
              </p>
            </div>
          </div>
        </div>

        <div className="contact-feedback">
          <Carousel
            responsive={responsive}
            showDots={true}
            infinite={true}
            renderDotsOutside={true}
          >
            <ReviewBox
              rate={5}
              name="Mark D"
              company="Trademark Genius"
              text="Trademark Genius helped register my companies trademark.
The process was simple, their customer service was excellent, and my trademark was registered without any issues.
Highly recommend Trademark Genius."
            />
            <ReviewBox
              rate={5}
              name="Kelly T"
              company="Trademark Genius"
              text="I contacted Trademark Genius after running into many issues trying to register my companies trademark myself.
They helped solve every issue i ran into. Would definitely recommend spending the money to have professionals handle
this process."
            />
            <ReviewBox
              rate={5}
              name="Terry F"
              company="Trademark Genius"
              text="Got my trademark registered with USPTO without any issues.
Their dashboard is a great tool and helped me track the progress of my application all the way to completion.
Will use them again for any other TM needs."
            />
            <ReviewBox
              rate={5}
              name="Devin M"
              company="Trademark Genius"
              text="My experience with TMG was great.
Their customer service team was friendly and helpful.
The process was quick & simple.
Thanks!"
            />
            <ReviewBox
              rate={5}
              name="Lisa N"
              company="Trademark Genius"
              text="My trademark registration was a unique situation that required some extra work, the team helped guide me through this daunting process and got my application submit to USPTO (and was approved without issues)
Thanks TMG!"
            />
            <ReviewBox
              rate={5}
              name="Marshall N"
              company="Trademark Genius"
              text="Great experience with Trademark Genius. They were knowledgeable, quick and accurate.
Helped iron out a few issues the USPTO was giving my application.
I’d definitely use them again."
            />
          </Carousel>
        </div>
      </div>
    );
  } else {
    return (
      <div className="contact">
        <NextSeo title="Contact Us" />
        <div className="side-wrapper">
          <div className="left-side">
            <div className="banner">
              {' '}
              <div className="mobile">
                <h1>Contact </h1>
                <h2>Customer Service</h2>
              </div>
            </div>
          </div>
          <div className="right-side">
            <div className="form">
              <div className="desktop">
                <h1>Contact </h1>
                <h2>Customer Service</h2>
              </div>
              <Form
                noValidate
                validated={state.validated}
                onSubmit={handleSubmit}
              >
                <Form.Group controlId="name">
                  <Form.Label>Full name</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Full name"
                    onChange={handleChange}
                    required
                    value={state.name ? state.name : ''}
                    data-hj-allow
                  />
                  <Form.Control.Feedback type="invalid">
                    Please provide a valid name
                  </Form.Control.Feedback>
                </Form.Group>
                <Form.Group controlId="email" className="form-group-email">
                  <Form.Label>Email</Form.Label>
                  <Form.Control
                    type="email"
                    required
                    placeholder="Email"
                    pattern="^(?!.*(?:''|\.\.))([a-zA-Z0-9_\-\.]*[a-zA-Z0-9_\-])@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$"
                    isValid={isEmailValid}
                    isInvalid={isEmailInvalid}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={state.email ? state.email : ''}
                    data-hj-allow
                  />
                  {state.verifying && (
                    <Form.Control.Feedback type="processing">
                      Verification...
                    </Form.Control.Feedback>
                  )}
                  <Form.Control.Feedback type="invalid">
                    {invalidEmailMessage}
                  </Form.Control.Feedback>
                  {state.verifying && (
                    <Spinner
                      animation="border"
                      variant="secondary"
                      className="form-control-loader"
                    />
                  )}
                </Form.Group>
                <Form.Group controlId="subject">
                  <Form.Label>Subject</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Subject"
                    onChange={handleChange}
                    required
                    value={state.subject ? state.subject : ''}
                    data-hj-allow
                  />
                  <Form.Control.Feedback type="invalid">
                    Please provide a valid subject
                  </Form.Control.Feedback>
                </Form.Group>
                <Form.Group controlId={'message'}>
                  <Form.Label>Message</Form.Label>
                  <Form.Control
                    as="textarea"
                    placeholder="Message"
                    required
                    name="message"
                    onChange={handleChange}
                    minLength={5}
                    style={{ height: '100px' }}
                  />
                  <Form.Control.Feedback type="invalid">
                    You must provide your question.
                  </Form.Control.Feedback>
                </Form.Group>
                <Button
                  id="ContactUsSendButton"
                  className="orange-btn"
                  type="submit"
                  style={{ border: 'none' }}
                >
                  Send Message
                </Button>
              </Form>
            </div>
          </div>
        </div>

        <div className="info">
          <div className="info-box">
            <div className="icon">
              <img
                src={`${publicRuntimeConfig.basePath}/call.png`}
                alt=""
                layout="fill"
              />
            </div>
            <div className="copy">
              <h4>CALL</h4>
              <p>
                <a href={'tel:' + phone} style={{ color: '#7B848D' }}>
                  <NumberFormat
                    value={phone.substring(2)}
                    displayType={'text'}
                    format="(###)### - ####"
                  />
                </a>
              </p>
            </div>
          </div>
          <div className="info-box">
            <div className="icon">
              <img
                src={`${publicRuntimeConfig.basePath}/email.png`}
                alt=""
                layout="fill"
              />
            </div>
            <div className="copy">
              <h4>EMAIL</h4>
              <p>
                <a href={'mailto:' + emailCompany} style={{ color: '#7B848D' }}>
                  {emailCompany}
                </a>
              </p>
            </div>
          </div>
          <div className="info-box">
            <div className="icon">
              <img
                src={`${publicRuntimeConfig.basePath}/email.png`}
                alt=""
                layout="fill"
              />
            </div>
            <div className="copy">
              <h4>HOURS</h4>
              <p>
                Monday - Friday:
                <br />
                9am - 5pm PST
              </p>
            </div>
          </div>
        </div>

        <div className="contact-feedback">
          <Carousel
            responsive={responsive}
            showDots={true}
            infinite={true}
            renderDotsOutside={true}
          >
            <ReviewBox
              rate={5}
              name="Mark D"
              company="Trademark Genius"
              text="Trademark Genius helped register my companies trademark.
The process was simple, their customer service was excellent, and my trademark was registered without any issues.
Highly recommend Trademark Genius."
            />
            <ReviewBox
              rate={5}
              name="Kelly T"
              company="Trademark Genius"
              text="I contacted Trademark Genius after running into many issues trying to register my companies trademark myself.
They helped solve every issue i ran into. Would definitely recommend spending the money to have professionals handle
this process."
            />
            <ReviewBox
              rate={5}
              name="Terry F"
              company="Trademark Genius"
              text="Got my trademark registered with USPTO without any issues.
Their dashboard is a great tool and helped me track the progress of my application all the way to completion.
Will use them again for any other TM needs."
            />
            <ReviewBox
              rate={5}
              name="Devin M"
              company="Trademark Genius"
              text="My experience with TMG was great.
Their customer service team was friendly and helpful.
The process was quick & simple.
Thanks!"
            />
            <ReviewBox
              rate={5}
              name="Lisa N"
              company="Trademark Genius"
              text="My trademark registration was a unique situation that required some extra work, the team helped guide me through this daunting process and got my application submit to USPTO (and was approved without issues)
Thanks TMG!"
            />
            <ReviewBox
              rate={5}
              name="Marshall N"
              company="Trademark Genius"
              text="Great experience with Trademark Genius. They were knowledgeable, quick and accurate.
Helped iron out a few issues the USPTO was giving my application.
I’d definitely use them again."
            />
          </Carousel>
        </div>
      </div>
    );
  }
}

export default Contact;
